import Perspective from './Perspective.vue';
import SlideFade from './SlideFade.vue';
import Fade from './Fade.vue';

export default {
  'x-effect-perspective': Perspective,
  'x-effect-slide-fade': SlideFade,
  'x-effect-fade': Fade,
}
